import cleanUpResponse from '@/util/cleanUpResponse';

export default async function ReassignOrder(formData) {
  const response = await $.soap({
    body: {
      ReassignOrder: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        OrderId: formData.orderId,
        CrsId: formData.crsId
      }
    }
  });

  cleanUpResponse(response);
  return response;
}